/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './ListGroup.scss'
import React from 'react'

/*
props {
  borderType: [default, underline, surround]
}
*/
function ListGroup(props) {
  const className = props.className || ''
  const borderType = props.border || 'default'

  return <ul className={`ListGroup ListGroup--${borderType} ${className}`}>{props.children}</ul>
}

export default ListGroup
